export default __webpack_public_path__ + "static/media/chair.df1dc202.svg";